/*

Entidade promotora - selecionar 1 (mostrar todas as opções possiveis)

Entidades envolvidas - selecionar várias (mostrar todas as opções possiveis)

Freguesia - selecionar várias (mostrar todas as opções possiveis)

BIP ZIP - funciona com numareos mas mostramos nomes. (Selecionar + que um)

AREA TEMÁTICA  - selecionar várias (mostrar todas as opções possiveis)

Objectivo e Relevância - TEXTO LIVRE (apenas uma entrada) max 1000CH 

RESPOSTAS E ACÇÔES SÃO DOIS CAMPOS DIFERENTES (Deixam de estar relacionados) - É possivel inserir novos  -FEITO


APAGAR MOrade e TAFONE  -FEITO

Como Podemos Ajudar? - SAI -FEITO
Fonte da Informação - SAI  -FEITO


DIFERENÇAS EXCEL ANTIGO - NOVO  -FEITO
DESAPARECE coluna: INFO UTIL e COMO -----> --FEITO




----------------------------FORM------------------------------------------

Email e nome do responsável logo em cima

OnSubmit: Mandar 2 emails - um para criador e outro para a camara  (com o código)
* O código é mais um campo de backoffice
*Não enviar para FE

SUBMETER O PROJECTO E FICA LOGO PUBLICO  

HISTORICO - FLAG (e adicionar ao FORM) - No mapa existe filtro "Ver projectos arquivados"


FORUM URBANO e COVID - Juntar "PARCEIROS" e "PROMOTOR" no mesmo filtro

- FE Filtro Histórico
- "Ficha de projecto:" fonte maior  -FEITO
- Divisores Entidades, Projecto /Accções ,  (ver no word)  -FEITO
- Arquivado para cima no Form  

- exportar excel do strapi

- Dividers (Está no Word)
- iconzinho + "actualizado" quando o projecto foi actualizado há pouco tempo (+ recente que X)
- Texto informativo aue está no word  --FEITO


- tirar "Creatable" de Recursos dispo. e necesssss (2) --FEITO


*/

//import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import { Checkbox, notification, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import relacaoFreguesias from '../data/dados_covid/relacao_BIPZIP_FREGUESIAS.json';
//import SubmitScreen from './SubmitScreen';
import {
  convertProjectData,
  convertProjectsBackToStrapiStructure
} from '../etl/utils';
import {
  getAllProjects,
  getProjectWithCode,
  postEditedSubmission,
  postNewSubmission
} from './../network/Submissions';

const delay = ms => new Promise(res => setTimeout(res, ms));

const InputStyle = {
  minWidth: 300,
  height: 38,
  fontFamily: 'Work Sans',
  padding: 5,
  fontSize: 15,
  //height: 30
  // margin: 10
  border: '1px solid #ccc',
  borderRadius: 4
};
const errorStyle = {
  textAlign: 'center',
  height: '21px',
  width: '300px',
  marginLeft: '10px',
  backgroundColor: 'rgb(247, 116, 117)',
  fontSize: '12px',
  color: '#fff',
  borderRadius: '5px',
  padding: '2px'
};
const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white' }),

  multiValue: (styles, { data }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      backgroundColor: '#f00'
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: '#0ff'
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: '#ff0',
    ':hover': {
      backgroundColor: data.color,
      color: 'white'
    }
  })
};

export const SubmitScreen = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [editingMode, setEditingMode] = useState(null);
  const [formState, setFormState] = useState({});
  const [finalProjectData, setFinalProjectData] = useState([]);
  const [dataWasReceveidFromBE, setDataWasReceveidFromBE] = useState(false);
  const [listOfErrors, setListOfErrors] = useState([]);
  const [
    submissionFailedDueToIncomplete,
    setSubmissionFailedDueToIncomplete
  ] = useState(false);

  // console.log('listOfErrors', listOfErrors);
  useEffect(() => {
    //DIDMOUNT

    async function getandSaveProjects() {
      props.setIsLoading(true);
      let rawProjects = await getAllProjects();
      props.setIsLoading(false);
      //STRAPI -->FE data conversion
      if (!rawProjects || !rawProjects.length > 0) {
        rawProjects = [];
      }

      // console.log('allProjects', allProjects);
      let temporaryProjectsData = convertProjectData(rawProjects); //STRAPI structure to old structure

      temporaryProjectsData = temporaryProjectsData.map(proposta => {
        let freguesiasDaProposta = [];
        let populacao = [];
        let nomeBairro = [];
        if (proposta['#Bip/Zip']) {
          proposta['#Bip/Zip'].forEach(numeroBipZip => {
            relacaoFreguesias.bairrosBipZip.forEach(bairro => {
              if (bairro['N BipZip'].toString() === numeroBipZip.toString()) {
                // some FREGUSIAS are more than 1 separated by $

                if (bairro.Freguesia.includes('$')) {
                  bairro.Freguesia.concat(toArray(bairro.Freguesia, '$'));
                } else {
                  freguesiasDaProposta.push(bairro.Freguesia);
                }
                populacao.push(bairro.População);
                nomeBairro.push(bairro.Bairro);
              }
            });
          });
        } else {
          // console.log(
          //   'proposta ',
          //   proposta['Quem sou Titulo'],
          //   'sem Bipzip',
          //   proposta
          // );
        }

        //DELETE REPEATED
        freguesiasDaProposta = freguesiasDaProposta.filter(function(
          item,
          pos,
          self
        ) {
          return self.indexOf(item) == pos;
        });

        // proposta['FREGUESIA'] = freguesiasDaProposta;
        proposta['populacao'] = populacao;
        //props.setIsLoading(false);
        // proposta['nomeBairroBipZip'] = nomeBairro;
        return proposta;
      });

      setFinalProjectData(temporaryProjectsData);
    }
    getandSaveProjects(); //WHYYYYY

    //  return () => {};
  }, []);

  let regularFieldStyle = {
    width: '40%',
    minWidth: '300px',
    padding: 10,
    paddingTop: 30
  };
  let textAreaStyle = { width: '100%', padding: 10, paddingTop: 30 };
  // console.log('formState', formState);
  return (
    <div>
      <div style={{ fontFamily: 'Frontage', fontSize: 35 }}>A sua Proposta</div>

      {isLoading ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            display: 'flex',
            width: '100vw',
            height: '100vh',
            backgroundColor: '#fff9',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
        >
          <Spin size="large" />
        </div>
      ) : null}

      {!dataWasReceveidFromBE ? (
        <>
          <EditForm />
          {editingMode === 'editing' ? editFormFields() : null}
          {editingMode !== 'editing' ? (
            //dont show this while editing becaus overlaps the form
            <div style={{ paddingTop: 10, fontStyle: 'italic' }}>
              Após a criação ou edição de projeto, ficará a aguardar validação
              para publicação no mapa.
            </div>
          ) : null}
          {!editingMode ? ( //text only appears before any options is choosen
            <div
              style={{
                // paddingTop: '30px',
                // fontFamily: 'Frontage',
                // fontStyle: 'normal',
                fontWeight: 200,
                //lineHeight: '14px',
                fontSize: '12px',
                paddingTop: 10,
                color: '#444'
              }}
            >
              A submissão e a atualização dos dados, assim como a indicação de
              conclusão ou término da resposta dos mesmos da plataforma, deverá
              ser exclusivamente das Entidades Promotoras através do responsável
              indicado. <br />
              <br />
              Após submissão de um projeto/resposta será enviado um email para o
              contacto indicado no formulário com o registo das informações
              preenchidas e -muito importante- um código secreto que deverá
              guardar. Este código servirá para poder posteriormente editar o
              seu projeto/ação. <br />
              <br />A Equipa BIP/ZIP analisa os elementos submetidos, ficando
              com a responsabilidade de os validar. Após validação os elementos
              que preencheu no formulário tornam-se públicos através do Mapa.{' '}
              <br />
              <br />
              Da análise dos elementos poderá resultar uma não validação, sendo
              dado às entidades promotoras a possibilidade de edição novas
              submissões até à validação e subsequente publicação. <br />
              <br />
              As entidades devem indicar o fim do Projeto/resposta, podendo
              transferir este recurso através da edição da mesma e verificação
              da opção de “projeto arquivado”. Apesar da transformação o
              projeto/resposta manter-se-á público e visível no mapa, mas já não
              como resposta existente e ativa.
            </div>
          ) : null}
        </>
      ) : null}

      {/* <RenderDivider /> */}

      {dataWasReceveidFromBE || editingMode === 'new_project' ? ( //ready to submit edited project
        <div style={{ paddingTop: 30 }}>
          <div
            style={{
              // paddingTop: '30px',
              fontFamily: 'Frontage',
              fontStyle: 'normal',
              fontWeight: 'normal',
              lineHeight: '25px',
              fontSize: '28px',
              letterSpacing: '-0.692308px',
              color: '#000000'
            }}
          >
            Ficha de projeto:
          </div>

          {renderFullForm()}
          {submitButton()}
        </div>
      ) : null}
    </div>
  );

  //var covidDataArrays = { projects: [] };
  function getAllOptions(key) {
    //console.log("getAllOptions for " + key);
    let allPossibleValues = [];

    finalProjectData.forEach(project => {
      //console.log(project);
      if (project[key]) {
        project[key].forEach(value => {
          if (allPossibleValues.indexOf(value) === -1) {
            allPossibleValues.push(value);
            allPossibleValues.sort();
          }
        });
      }
    });

    //react-select uses array of {label: something, value:something} so we have to convert the array
    allPossibleValues = allPossibleValues.map(field => ({
      label: field,
      value: field
    }));

    //console.log('allPossibleValues', allPossibleValues);
    return allPossibleValues;
  }

  function renderDivider(title) {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: 30
          // paddingBottom: 30
        }}
      >
        <div style={{ width: '20%', borderTop: '1px solid #aaa' }}></div>
        <div
          style={{
            // paddingTop: '30px',
            fontFamily: 'Frontage',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '25px',
            fontSize: '22px',
            padding: 10,
            letterSpacing: '-0.692308px',
            color: '#000000'
          }}
        >
          {title}
        </div>
        <div style={{ width: '20%', borderTop: '1px solid #aaa' }}></div>
      </div>
    );
  }
  function renderFullForm() {
    // console.log('covidDataArrays', covidDataArrays.projects);
    return (
      <div
        style={{
          width: '100%',
          height: 'auto',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap'
        }}
      >
        {renderDivider('Entidades')}
        {editingMode !== 'editing'
          ? formField({
              label: 'Email Contacto',
              field: 'Email contacto',
              type: 'string',
              instrucoes: `Indicar o contacto email que ficará disponível e visível na plataforma para possíveis partilhas e sinergias entre Projetos/Iniciativas/Ações.
Este contacto deverá estar sempre relacionado com o técnico indicado como responsável desta resposta.`
            })
          : null}
        {formField({
          label: 'Nome do Responsável',
          field: 'Nome contacto',
          type: 'string',
          instrucoes: `Identificar o nome da/o responsável /coordenador/a das respostas existentes
Esta/e responsavel fará a articulação com outras entidades na partilha das respostas e recursos e o ponto de contacto com a Equipa BIP/ZIP para a submissão, validação e atualização dos elementos do projeto a serem divulgadas nesta plataforma.`
        })}
        {formField({
          label: 'Nome do projeto',
          field: 'Quem sou',
          type: 'string',
          instrucoes:
            'Identificar o nome do projeto ou ação de resposta às consequências da Pandemia COVID 19. Se se tratar de um projeto BIP/ZIP deverá aqui ser colocado o nome desse projeto'
        })}
        {/* {formField({
          label: 'Título Breve',
          field: 'Quem sou Titulo',
          type: 'string',
          instrucoes: null
        })} */}
        {formField({
          label: 'Promotora',
          field: 'EntidadePromotora',
          type: 'promotora_special',
          instrucoes:
            'Identificar a entidade responsável por esta/s iniciativa/s de resposta à COVID 19'
        })}

        {formField({
          label: 'Parceiros',
          field: 'Nome entidades',
          type: 'array',
          instrucoes: 'Identificar a/s outras entidades envolvidas na Resposta'
        })}

        {renderDivider('Projeto/Ação')}

        {formField({
          label: 'descrição proposta',
          field: 'descrição proposta',
          type: 'textarea',
          instrucoes: `Breve síntese do que se pretende com este Projeto/Ação.
Não devem aqui ser referenciados as respostas concretas nem os respetivos recursos já que serão referidos mais concretamente nos campos seguintes. (Máximo de 1500 caracteres)`
        })}
        {formField({
          label: 'Freguesias',
          field: 'FREGUESIA',
          type: 'array',
          instrucoes: `Identificar a/s freguesia/s de intervenção`
        })}
        {formField({
          label: 'Bairros BipZip',
          field: '#Bip/Zip',
          type: 'bipZip_array',
          instrucoes: `Identificar qual/ais o/s territórios BIP/ZIP abrangido/s por este Projeto/Ação`
        })}
        {formField({
          label: 'Áreas temáticas',
          field: 'áreas temáticas',
          type: 'array',
          instrucoes: `Identificar qual/ais a/s área/s temáticas desta intervenção`
        })}
        {formField({
          label: 'Objectivo Relevante',
          field: 'objectivo e relevância',
          type: 'textarea',
          instrucoes: `Identifique o objectivo principal mais relevante e o que se pretende concretamente com o Projeto/Ação. (Máximo de 1500 caracteres) `
        })}

        {renderDivider('Respostas/Ações')}

        {formField({
          label: 'Respostas COVID',
          field: 'Respostas COVID',
          type: 'array',
          instrucoes: `Indique das listas uma ou mais respostas que estão a ser promovidas pelo Projeto/ação. Caso a resposta não conste na lista, poderá escrever na barra da lista e adicionar uma nova.`
        })}
        {formField({
          label: 'Ações',
          field: 'lista acções',
          type: 'array',
          instrucoes: `Indique das listas uma ou mais ações que estão a ser promovidas pelo Projeto/ação. Caso a ação não conste na lista, poderá escrever na barra da lista e adicionar uma nova.`
        })}

        {renderDivider('Recursos')}

        {formField({
          label: 'Recursos disponíveis',
          field: 'DISPONIBILIZO',
          type: 'array',
          instrucoes: `A identificação dos Recursos Disponíveis tem como principal objetivo, com a sua divulgação nesta Plataforma, dar a conhecer os Recursos que existem ou passam a existir num dado território, possibilitando a criação de sinergias com outros recursos e evitando duplicação de recursos`
        })}
        {formField({
          label: 'Descrição de recursos disponíveis',
          field: 'descrição recursos disponiveis',
          type: 'textarea',
          instrucoes:
            'Indique neste campo quais os recursos que a sua organização e /ou consórcio podem disponibilizar para que outras organizações possam implementar as suas soluções a partir desta sinergia. (Máximo de 1500 caracteres)'
        })}
        {formField({
          label: 'Recursos necessários',
          field: 'NECESSITO',
          type: 'array',
          instrucoes: `A identificação dos Recursos Necessário tem como principal objetivo, com a sua divulgação nesta Plataforma, dar a conhecer as necessidades que possam já existir noutras respostas possibilitando a criação de sinergias com outros recursos e outras respostas já implementadas nesse ou noutros territórios.`
        })}
        {formField({
          label: 'Descrição de recursos necessários',
          field: 'descrição recursos necessita',
          type: 'textarea',
          instrucoes:
            'Indique neste campo quais os recursos que a sua organização e/ou consórcio necessitam para implementar a iniciativa/ação de resposta. (Máximo de 1500 caracteres)'
        })}

        {editingMode == 'editing'
          ? formField({
              label: 'projeto Arquivado',
              field: 'Arquivado',
              type: 'checkbox',
              instrucoes: `Caso o projeto/ação já não esteja a ser desenvolvido ou tenha terminado deverá verificar a seguinte caixa.
Apesar da transformação o projeto/resposta manter-se-á público e visível no mapa, mas já não como resposta existente e ativa.`
            })
          : null}
      </div>
    );
  }
  function editFormFields() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: 'auto',
          alignItems: 'flex-end',
          justifyContent: 'space-between'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            {renderTitle('Email')}
            {renderInstrucoes(
              `Coloque aqui o email que registou quando submeteu o projecto. Caso não se recorde contacte a equipa BIP/ZIP.`
            )}
            <input
              key={'Email contacto'}
              value={formState.email}
              style={{ ...InputStyle }}
              onChange={e => {
                let value = e.target.value;
                //  console.log('CHANGE', e);
                handleFormChange('Email contacto', value);
              }}
            ></input>
          </div>
          <div style={{ paddingTop: 30 }}>
            {renderTitle('O seu código')}
            {renderInstrucoes(
              `Coloque aqui o código secreto que recebeu no seu email quando submeteu o projecto. Caso não se recorde contacte a equipa BIP/ZIP.`
            )}
            <input
              style={{ ...InputStyle }}
              onChange={e => {
                let value = e.target.value;
                // console.log('CHANGE', e);
                handleFormChange('codigo', value);
              }}
            ></input>
          </div>
        </div>

        <div>
          <button
            onClick={async () => {
              if (!formState['codigo'] || !formState['Email contacto']) {
                notification.error({
                  message: 'Insira um email válido e o seu código',
                  description: 'Erro na submissão.' //response.message
                });
                // props.setSubmitModalVisible(false);
                return;
              }
              props.setIsLoading(true);
              let response = await getProjectWithCode(
                formState['codigo'],
                formState['Email contacto']
              );

              // console.log('response', response);

              if (response.error) {
                notification.error({
                  message: 'Email ou código inválidos',
                  description: 'Por favor, confira os campos' //response.message
                  // style: { zIndex: 3000 }
                });
                props.setIsLoading(false);
                return;
              }
              let project = convertProjectData([response]);

              project = project[0]; //no array
              //  console.log('project', project);
              fillExistentProject(prev => ({
                ...prev, //data before - like the code
                ...project //new date from
              }));
              props.setIsLoading(false);
              setDataWasReceveidFromBE(true); //show the form already filled
            }}
            style={{
              padding: 10,
              //margin: 10,
              fontFamily: 'Frontage',
              fontSize: 20,
              cursor: 'pointer'
            }}
          >
            Obter dados da proposta
          </button>
        </div>
      </div>
    );
  }
  function EditForm() {
    return (
      <div
        style={{
          paddingTop: '30px',
          fontFamily: 'Frontage',
          fontStyle: 'normal',
          fontWeight: 'normal',
          lineHeight: '25px',
          fontSize: '18px',
          letterSpacing: '-0.692308px',
          color: '#000000'
        }}
      >
        <div onChange={onChangeValue}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <input
              type="radio"
              id="new_project"
              name="editingProjectRadio"
              value="new_project"
              checked={editingMode == 'new_project'}
              onChange={() => {}}
              style={{ height: 20, width: 20 }}
            />

            <div style={{ padding: 10 }}> Quero adicionar um novo projeto</div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              paddingBottom: 10
            }}
          >
            <input
              type="radio"
              id="editing"
              name="editingProjectRadio"
              value="editing"
              onChange={() => {}}
              checked={editingMode == 'editing'}
              style={{ height: 20, width: 20 }}
            />
            <div style={{ padding: 10 }}>Quero editar o meu projeto</div>
          </div>
        </div>
      </div>
    );
  }

  function BreakLine() {
    return (
      <div
        style={{
          width: '40%'
        }}
      ></div>
    );
  }
  function onChangeValue(event) {
    // console.log(event.target.value);

    //
    setEditingMode(event.target.value);
  }

  function handleFormChange(key, value) {
    setFormState(prevState => {
      return { ...prevState, [key]: value };
    });
  }

  function renderTitle(title) {
    return (
      <div
        style={{
          // paddingTop: '30px',
          fontFamily: 'Frontage',
          fontStyle: 'normal',
          fontWeight: 'normal',
          lineHeight: '25px',
          fontSize: '18px',
          paddingRight: 10,
          letterSpacing: '-0.692308px',
          color: '#000000'
        }}
      >
        {title}
      </div>
    );
  }

  function renderInstrucoes(text) {
    return (
      <div
        style={{
          // paddingTop: '30px',
          // fontFamily: 'Frontage',
          // fontStyle: 'normal',
          fontWeight: 200,
          lineHeight: '12px',
          fontSize: '10px',
          paddingBottom: 10,
          color: '#444'
        }}
      >
        {text}
      </div>
    );
  }
  function formField(field) {
    if (field.type === 'string') {
      return (
        <div style={regularFieldStyle}>
          {renderTitle(field.label)}
          {renderInstrucoes(field.instrucoes)}
          {renderSimpleInputString(field.field)}
        </div>
      );
    }
    if (field.type === 'array') {
      //console.log('FIELD IS ', field, 'and ');
      return (
        <div style={regularFieldStyle}>
          {renderTitle(field.label)}
          {renderInstrucoes(field.instrucoes)}
          {renderArrayInput(field.field)}
        </div>
      );
    }
    if (field.type === 'promotora_special') {
      //console.log('FIELD IS ', field, 'and ');
      return (
        <div style={regularFieldStyle}>
          {renderTitle(field.label)}
          {renderInstrucoes(field.instrucoes)}
          {renderArrayInputPromotora(field.field)}
        </div>
      );
    }
    if (field.type === 'bipZip_array') {
      //console.log('FIELD IS ', field, 'and ');
      return (
        <div style={regularFieldStyle}>
          {renderTitle(field.label)}
          {renderInstrucoes(field.instrucoes)}
          {renderBipZipArrayField(field.field)}
        </div>
      );
    }
    if (field.type === 'textarea') {
      return (
        <div style={textAreaStyle}>
          {renderTitle(field.label)}
          {renderInstrucoes(field.instrucoes)}
          {renderTextArea(field.field)}
        </div>
      );
    }
    if (field.type === 'checkbox') {
      return (
        <div
          style={{
            maxWidth: 350,
            padding: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}
        >
          <div
            style={{
              paddingTop: 30,
              width: 'auto',
              display: 'flex',
              flexDirection: 'row',
              alignContent: 'center',
              justifyContent: 'space-around'
            }}
          >
            {renderTitle(field.label)}
            {renderCheckBoxField(field.field)}
          </div>
          {renderInstrucoes(field.instrucoes)}
        </div>
      );
    }
  }

  function renderSimpleInputString(field) {
    if (!formState[field] && formState[field] !== '') {
      handleFormChange(field, '');
      setListOfErrors(prev => ({ ...prev, [field]: true }));
    }

    return (
      <div>
        <input
          type="string"
          name={field}
          value={formState[field] ? formState[field] : ''}
          //  onBlur={() => validateForm()}
          // placeholder={'Território BipZip'}
          style={{
            ...InputStyle,
            border: listOfErrors[field]
              ? submissionFailedDueToIncomplete
                ? '2px solid #B56576'
                : '1px solid #ccc'
              : '2px solid #CFD2B2'
          }}
          onChange={event => {
            if (!event.target.value) {
              setListOfErrors(prev => ({ ...prev, [field]: true }));
            } else {
              setListOfErrors(prev => ({ ...prev, [field]: null }));
            }

            handleFormChange(field, event.target.value);
          }}
        />
        {/* {formState.errors[field] ? (
          <div style={errorStyle}>{formState.errors[field]}</div>
        ) : null} */}
        {/* <ErrorMessage name={field} component="div" style={errorStyle} /> */}
      </div>
    );
  }

  function renderCheckBoxField(field) {
    if (!formState[field] && formState[field] !== false) {
      handleFormChange(field, false);
      //setListOfErrors(prev => ({ ...prev, [field]: true }));
    }

    return (
      <div>
        <Checkbox
          checked={formState[field]}
          onChange={e => {
            //  console.log(`checked = ${e.target.checked}`);
            handleFormChange(field, e.target.checked);
          }}
        ></Checkbox>
      </div>
    );
  }
  function renderArrayInput(field) {
    // console.log('YO!', field, formState);

    if (!formState[field]) {
      handleFormChange(field, []);
      setListOfErrors(prev => ({ ...prev, [field]: true })); //it is empty
    }
    // if (!field.field) {
    //   return null;
    // }
    let reactSelectData = [];
    if (!formState[field]) {
      handleFormChange(field, []);
    } else {
      reactSelectData = formState[field].map(element => ({
        label: element,
        value: element
      }));
    }

    let recursos = [];

    if (field === 'DISPONIBILIZO' || field === 'NECESSITO') {
      recursos = [
        'Bens Alimentares',
        'Bens não Alimentares',
        'Espaços',
        'Recursos Financeiros',
        'Recursos humanos',
        'Recursos Tecnológicos',
        'Serviços'
      ];

      recursos = recursos.map(element => ({
        label: element,
        value: element
      }));
    }

    return field === 'DISPONIBILIZO' || field === 'NECESSITO' ? (
      <Select
        //defaultValue={[options[0], options[1]]}
        value={reactSelectData}
        onChange={newArray => {
          console.log(newArray);
          newArray = newArray.map(element => element.label);

          handleFormChange(field, newArray);
          if (newArray?.length > 0) {
            setListOfErrors(prev => ({ ...prev, [field]: false }));
          } else {
            setListOfErrors(prev => ({ ...prev, [field]: true })); //it is empty
          }
        }}
        styles={{
          control: (provided, state) => ({
            ...provided,
            border: listOfErrors[field]
              ? submissionFailedDueToIncomplete
                ? '2px solid #B56576'
                : '1px solid #ccc'
              : '2px solid #CFD2B2'
          })
        }}
        formatCreateLabel={inputValue => 'Criar novo campo ' + inputValue}
        placeholder={'Selecione...'}
        isMulti
        name="colors"
        options={recursos}
        // styles={colourStyles}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    ) : (
      //For all other that are creatable
      <CreatableSelect
        //defaultValue={[options[0], options[1]]}
        value={reactSelectData}
        onChange={newArray => {
          newArray = newArray.map(element => element.value);

          handleFormChange(field, newArray);
          if (newArray?.length > 0) {
            setListOfErrors(prev => ({ ...prev, [field]: false }));
          } else {
            setListOfErrors(prev => ({ ...prev, [field]: true })); //it is empty
          }
        }}
        styles={{
          control: (provided, state) => ({
            ...provided,
            border: listOfErrors[field]
              ? submissionFailedDueToIncomplete
                ? '2px solid #B56576'
                : '1px solid #ccc'
              : '2px solid #CFD2B2'
          })
        }}
        formatCreateLabel={inputValue => 'Criar novo campo ' + inputValue}
        placeholder={'Selecione...'}
        isMulti
        name="colors"
        options={getAllOptions(field)}
        // styles={colourStyles}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    );
  }
  function renderArrayInputPromotora(field) {
    //  console.log('formState', formState);
    // console.log('YO!', field, formState);

    // if (!formState[field] && !formState[field] !== '') {
    //   handleFormChange(field, '');
    // }
    let reactSelectData = [];
    if (!formState[field] && formState[field] !== '') {
      handleFormChange(field, '');
      setListOfErrors(prev => ({ ...prev, [field]: true })); //it is empty
    } else {
      reactSelectData = {
        label: formState[field],
        value: formState[field]
      };
    }

    return (
      //For all other that are creatable
      <CreatableSelect
        //defaultValue={[options[0], options[1]]}
        value={reactSelectData}
        onChange={newArray => {
          console.log('newArray', newArray);
          //Promotora uses the values of entidades - SPECIAL TREATMENT
          handleFormChange(field, newArray.value);
          if (newArray?.value) {
            setListOfErrors(prev => ({ ...prev, [field]: false }));
          } else {
            setListOfErrors(prev => ({ ...prev, [field]: true })); //it is empty
          }
          return;
        }}
        styles={{
          control: (provided, state) => ({
            ...provided,
            border: listOfErrors[field]
              ? submissionFailedDueToIncomplete
                ? '2px solid #B56576'
                : '1px solid #ccc'
              : '2px solid #CFD2B2'
          })
        }}
        formatCreateLabel={inputValue => 'Criar novo campo ' + inputValue}
        placeholder={'Selecione...'}
        isMulti={false}
        name="colors"
        options={getAllOptions('Nome entidades')} //Promotora uses the values of entidades
        // styles={colourStyles}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    );
  }

  function renderBipZipArrayField(field) {
    let reactSelectData = [];
    if (!formState[field]) {
      handleFormChange(field, []);
      setListOfErrors(prev => ({ ...prev, [field]: true }));
    } else {
      reactSelectData = formState[field].map(element => {
        //get bipzip number
        //console.log('BIPZIP EL', element);
        let bipZipInfo = relacaoFreguesias.bairrosBipZip.find(
          bairro => parseInt(element) === bairro['N BipZip']
        );
        // console.log('bipZipInfo', bipZipInfo);

        if (!bipZipInfo) {
          return null;
        }

        return {
          label: bipZipInfo['Bairro'],
          value: bipZipInfo['N BipZip']
        };
      });
    }

    return (
      <Select
        //defaultValue={[options[0], options[1]]}
        value={reactSelectData}
        onChange={newArray => {
          // console.log(newArray);
          newArray = newArray.map(element => element.value.toString());
          handleFormChange(field, newArray);
          if (newArray?.length > 0) {
            setListOfErrors(prev => ({ ...prev, [field]: true }));
          }
          {
            setListOfErrors(prev => ({ ...prev, [field]: false }));
          }
        }}
        styles={{
          control: (provided, state) => ({
            ...provided,
            border: listOfErrors[field]
              ? submissionFailedDueToIncomplete
                ? '2px solid #B56576'
                : '1px solid #ccc'
              : '2px solid #CFD2B2'
          })
        }}
        // formatCreateLabel={inputValue => 'Criar novo campo ' + inputValue}
        placeholder={'Selecione...'}
        isMulti
        name="bip_zip"
        options={getAllBipzips()}
        // styles={colourStyles}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    );
  }

  function getAllBipzips() {
    return relacaoFreguesias.bairrosBipZip.map(bairro => ({
      value: bairro['N BipZip'],
      label: bairro['Bairro']
    }));
  }
  function renderTextArea(field) {
    //DescricaoProposta

    if (!formState[field] && formState[field] !== '') {
      handleFormChange(field, '');
      setListOfErrors(prev => ({ ...prev, [field]: true }));
    }
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <textarea
          maxLength={1500}
          value={formState[field]}
          onBlur={() => {
            // this.validateForm();
          }}
          onChange={e => {
            let newData = formState[field];
            newData = e.target.value;
            handleFormChange(field, newData);
            if (!newData) {
              setListOfErrors(prev => ({ ...prev, [field]: true })); //it is empty
            } else {
              setListOfErrors(prev => ({ ...prev, [field]: false }));
            }
          }}
          as={'textarea'}
          type="string"
          name={field}
          rows="5"
          //placeholder={'Território BipZip'}
          style={{
            ...InputStyle,
            border: listOfErrors[field]
              ? submissionFailedDueToIncomplete
                ? '2px solid #B56576'
                : '1px solid #ccc'
              : '2px solid #CFD2B2',
            width: '100%',
            height: 150,
            padding: 10,
            margin: 0
            // marginTop: 10
          }}
        />
        {/* {this.state.errors[field] ? (
          <div style={{ ...errorStyle, marginTop: 10 }}>
            {this.state.errors[field]}
          </div>
        ) : null} */}
      </div>
    );
  }

  function fillEmptyProject() {}
  function fillExistentProject(formData) {
    Object.keys(formState).forEach(key => {
      if (!formState[key]) {
        setListOfErrors(prev => ({ ...prev, [key]: true })); //it is empty
      } else {
        setListOfErrors(prev => ({ ...prev, [key]: false }));
      }
    });

    // let projectData = convertProjectData(); //TODO!
    setFormState(formData);
  }
  function submitButton() {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: 10
        }}
      >
        <button
          onClick={async () => {
            try {
              setIsLoading(true);
              await delay(1000);

              await submitForm(formState);

              await delay(2000);
              setIsLoading(false);
            } catch (err) {
              //  message.error(err);
              console.log('Error', err);
              setIsLoading(false);
            }
            // setTimeout(() => console.log('starting POST'), 2000);
          }}
          style={{
            padding: 10,
            margin: 10,
            fontFamily: 'Frontage',
            fontSize: 30,
            cursor: 'pointer'
          }}
        >
          Submeter proposta
        </button>
      </div>
    );
  }
  async function submitForm() {
    let validationErrors = Object.keys(listOfErrors).filter(
      key => listOfErrors[key] //filter errors === true --> means they are active
    );
    if (validationErrors.length > 0) {
      //  let errorMessage = validationErrors;

      notification.error({
        message: 'Existem campos por preencher:',
        description: 'Verifique campos a vermelho' //response.message
        // style: { zIndex: 3000 }
      });
      setSubmissionFailedDueToIncomplete(true); //changes the missing fields to RED
      return;
    }

    let tempFormState = JSON.parse(JSON.stringify(formState)); //force object clone to avoid state previous bugs

    tempFormState = convertProjectsBackToStrapiStructure(tempFormState);
    //  console.log('After Conver to Strapi:', tempFormState);
    let response = {};
    if (editingMode === 'editing') {
      // console.log('temp_formData', JSON.stringify(temp_formData));
      response = await postEditedSubmission(
        JSON.parse(JSON.stringify(tempFormState))
      );
    }
    if (editingMode === 'new_project') {
      response = await postNewSubmission(
        JSON.parse(JSON.stringify(tempFormState))
      );
    }

    if (response.error) {
      notification.error({
        message: 'Verifique os campos em falta:',
        description: 'Erro na submissão.' //response.message
        // style: { zIndex: 3000 }
      });

      return;
    } else {
      //TODO if no ERROR from API, is assuming is correctly submitted (maybe not enough)
      //   console.log('TCHAAN TCHAAAAAN', response);
      notification.success({
        message: 'Submetido com sucesso!',
        description: 'Pendente de validação.' //response.message
        // style: { zIndex: 3000 }
      });
      props.setSubmitModalVisible(false);
      //return;
    }
  }
};
const toArray = (
  str,
  separator //transform an sting separated by $ in array
) =>
  str
    .trim()
    .split(separator)
    .map(str => str.trim())
    .filter(str => str.length > 0);
